import { render, staticRenderFns } from "./uselog.vue?vue&type=template&id=61be16d3"
import script from "./uselog.vue?vue&type=script&lang=ts"
export * from "./uselog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports